/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { NavLink, Link } from "react-router-dom";
// eslint-disable-next-line import/no-unresolved
import Logo from "./newlogo.png";

const onMouseEnter = (event, color) => {
  const el = event.target;
  el.style.backgroundColor = color;
};

const onMouseOut = (event) => {
  const el = event.target;
  el.style.backgroundColor = "transparent";
};

const Header = () => {
  return (
    <Fade top duration={1000} distance="20px">
      <div>
        <header className="header">
          <a href="/">
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={Logo} alt="data" style={{ width: "70px" }} />
              <span className="logo-name">Kishimoto Inu</span>
            </div>
          </a>

          <ul className="menu">
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="">Home</a>
            </li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="">Buy Now</a>
            </li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="">Swap</a>
            </li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="">NFTs</a>
            </li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="">Twitter</a>
            </li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="">Telegram</a>
            </li>
          </ul>
        </header>
      </div>
    </Fade>
  );
};
export default Header;
